/**
 * @typedef {Object} Portalgo020
 * @property {string} nonce - WordPress nonce for security
 * @property {string} ajaxurl - WordPress AJAX URL
 * @property {string} category_id - Current category ID
 */

/** @type {Portalgo020} */
/* global portalgo020 */

; (function () {
  'use strict'

  document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('.js-category-ajax-load-more')
    const container = document.querySelector('.js-category-ajax-container')

    if (!button || !container) {
      console.warn('Botão ou container não encontrados')
      return
    }

    // Verificar se temos as variáveis necessárias
    if (
      !portalgo020 ||
      !portalgo020.ajaxurl ||
      !portalgo020.nonce ||
      !portalgo020.category_id
    ) {
      console.error('Variáveis do WordPress não encontradas:', portalgo020)
      return
    }

    let loading = false
    let postsLoaded = 1 // Começamos com 1 post já carregado

    function updateButtonState(isLoading, shouldRemove = false) {
      if (!button) return

      if (shouldRemove) {
        button.style.display = 'none'
        return
      }

      button.disabled = isLoading
      button.textContent = isLoading ? 'Carregando...' : 'Carregar mais'
    }

    function loadMorePosts() {
      if (loading) {
        return
      }

      loading = true
      updateButtonState(true)

      const data = new FormData()
      data.append('action', 'load_more_posts')
      data.append('nonce', portalgo020.nonce)
      data.append('category_id', portalgo020.category_id)
      data.append('offset', postsLoaded)

      console.log('Carregando mais posts:', {
        offset: postsLoaded,
        category_id: portalgo020.category_id,
      })

      fetch(portalgo020.ajaxurl, {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .then((result) => {
          console.log('Resposta do servidor:', result)

          if (
            result.success &&
            result.data &&
            result.data.html &&
            result.data.html.trim()
          ) {
            container.insertAdjacentHTML('beforeend', result.data.html)
            postsLoaded += 1

            updateButtonState(false, !result.data.has_more)
          } else {
            console.warn('Nenhum post encontrado ou erro na resposta:', result)
            updateButtonState(false, true)
          }
        })
        .catch((error) => {
          console.error('Erro ao carregar posts:', error)
          updateButtonState(false, true)
        })
        .finally(() => {
          loading = false
        })
    }

    button.addEventListener('click', loadMorePosts)
  })
})()
